import noop from 'lodash/noop';
import { put } from 'redux-saga/effects';

import * as Constants from '../../../constants';
import { getInDomain } from '../../../domains/externalUtils';

export function* signUpClicked() {
  const logEvent = getInDomain('analytics.actions.logEvent', noop);
  yield put(
    logEvent({
      eventType: Constants.Analytics.EventTypes.CLICK,
      eventName: Constants.Analytics.EventNames.CLICKED_SIGN_UP,
      eventData: {
        tier: Constants.Payments.Tiers.AD_SUPPORTED,
        discountType: Constants.Payments.DiscountTypes.NONE,
        isTrial: false,
      },
    }),
  );
}
